import { QueryClient } from '@tanstack/react-query';
export function createCmsQueryClient() {
    return new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: 30000,
                gcTime: 5 * 60000,
                refetchOnWindowFocus: true,
                refetchOnReconnect: true,
                retry: 2,
            },
            mutations: {
                retry: 0,
            },
        },
    });
}
